// src/Api/Api.jsx
import axios from "axios";

// ✅ 1. Yahan BASE_API define karein aur export karein taaki Config isko le sake
// export const BASE_API = "http://15.206.185.228"; 

export const BASE_API = "https://communityrishtey.in";
// export const BASE_API = "http://127.0.0.1:8000";

const BASE_URL = BASE_API.replace(/\/+$/, '');

const Api = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
});

// ============================================================
// ✅ PUBLIC - Sirf GET requests ke liye no token
// ============================================================
const PUBLIC_GET_ENDPOINTS = [
    'send-phone-otp',
    'verify-phone-otp',
    'UserReg_wl',
    'UserDataReg_wl',
    'UserLogin',
    'caste',
    'state',
    'state-districts',
    'district',
    'caste/by-religion',
    'promotions',
    'premium-plans',
    'api/check-username',
    'successstories',   // ← GET only public
];

const PUBLIC_POST_ENDPOINTS = [
    'send-email/',          // ← Forget password email
    'UserLogin/',           // ← Login
    'UserReg_wl/',          // ← Registration
    'UserRegister/',        // ← Registration
    'send-otp/',            // ← OTP send
    'verify-otp/',          // ← OTP verify
    'api/send-otp/',        // ← OTP send
    'api/verify-otp/',      // ← OTP verify
    'api/resend-otp/',      // ← OTP resend
    'send-login-otp/',      // ← Login OTP
    'verify-login-otp/',    // ← Login OTP verify
    'send-phone-otp/',      // ← Phone OTP
    'verify-phone-otp/',    // ← Phone OTP verify
    'api/validate-referral/', // ← Referral validate
    'create-order/',      // ← ADD
    'verify-payment/',
    'UserDataReg_wl/'
];

// ============================================================
// ✅ Check - sirf GET + public
// ============================================================
const isPublicGet = (url, method) => {
    if (!url) return false;
    const isGet = (method || '').toLowerCase() === 'get';
    return isGet && PUBLIC_GET_ENDPOINTS.some(ep => url.includes(ep));
};

const isPublicPost = (url, method) => {
    if (!url) return false;
    const isPost = (method || '').toLowerCase() === 'post';
    return isPost && PUBLIC_POST_ENDPOINTS.some(ep => url.includes(ep));
};

// ============================================================
// ✅ Request Interceptor
// ============================================================
Api.interceptors.request.use(
    (config) => {
        const url = config.url || '';
        const method = config.method || 'get';

        // ✅ GET + public = no token
        if (isPublicGet(url, method)) {
            console.log(`🔓 Public GET: ${url}`);
            return config;
        }

        if (isPublicPost(url, method)) {
            console.log(`🔓 Public POST: ${url}`);
            return config;
        }


        // ✅ For PUT/PATCH/DELETE - remove trailing slash
        if (['put', 'patch', 'post'].includes(method.toLowerCase())) {
            // Add trailing slash if missing (Django requires it for these methods)
            if (url && !url.endsWith('/') && !url.includes('?')) {
                config.url = url + '/';
                console.log(`🔧 Added trailing slash: ${config.url}`);
            }
        }

        // ✅ Token required
        const token = localStorage.getItem("access_token");

        if (!["/api/token/", "/api/token/refresh/"].some(u => url.endsWith(u))) {
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
                console.log(`🔒 Auth ${method.toUpperCase()}: ${config.url}`);
            } else {
                console.log(`⚠️ No token: ${url}`);
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// ============================================================
// ✅ Token Refresh Setup
// ============================================================
let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => refreshSubscribers.push(cb);

const onTokenRefreshed = (token) => {
    refreshSubscribers.forEach(cb => cb(token));
    refreshSubscribers = [];
};

const refreshToken = async () => {
    const refresh = localStorage.getItem("refresh_token");

    if (!refresh) {
        console.warn("⚠️ No refresh token");
        return null;
    }

    try {
        const res = await axios.post(
            `${BASE_URL}/api/token/refresh/`,
            { refresh },
            { headers: { "Content-Type": "application/json" }, timeout: 10000 }
        );

        const newToken = res.data.access;
        localStorage.setItem("access_token", newToken);
        if (res.data.refresh) {
            localStorage.setItem("refresh_token", res.data.refresh);
        }

        console.log("✅ Token refreshed");
        return newToken;

    } catch (err) {
        console.error("❌ Refresh failed:", err.response?.status);
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");

        if (!window.location.pathname.includes("Login") &&
            !window.location.pathname.includes("Reg")) {
            setTimeout(() => {
                window.location.href = "/User_Login";
            }, 1000);
        }
        return null;
    }
};

// ============================================================
// ✅ Response Interceptor
// ============================================================
Api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const url = originalRequest?.url || '';
        const method = originalRequest?.method || 'get';

        // ✅ Public GET fail = normal reject
        if (isPublicGet(url, method)) {
            console.log(`🔓 Public GET failed: ${url}`);
            return Promise.reject(error);
        }

        // ✅ 401 = try refresh
        if (error.response?.status === 401 && !originalRequest._retry) {

            if (isRefreshing) {
                return new Promise((resolve) => {
                    subscribeTokenRefresh((token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        resolve(Api(originalRequest));
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const newToken = await refreshToken();
            isRefreshing = false;

            if (newToken) {
                onTokenRefreshed(newToken);
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return Api(originalRequest);
            }
        }

        return Promise.reject(error);
    }
);

// Ye Axios ka instance export ho raha hai
export default Api;